var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSrIconBaby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 283.5",
    style: {
      enableBackground: "new 0 0 283.5 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4C446E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242,125.2h-1.8c-3.9-9.9-9.4-19.2-16.2-27.6c-12.3-15.1-28.5-26.5-46.7-33c-1.4-0.5-2.9-0.4-4.3,0.2 c-1.3,0.6-2.4,1.8-2.9,3.2s-0.4,2.9,0.2,4.3s1.8,2.4,3.2,2.9c16.3,5.8,30.8,16,41.8,29.5c11.1,13.7,18.2,30.2,20.3,47.6 c0.3,2.8,2.7,4.9,5.6,4.9c0.2,0,0.5,0,0.7,0c1.5-0.2,2.8-0.9,3.7-2.1c0.9-1.2,1.3-2.6,1.1-4.1c-0.6-4.9-1.6-9.7-2.8-14.4 c12.1,1,21.6,11.1,21.6,23.4c0,13-10.6,23.5-23.5,23.5h-3.2c-2.6,0-4.8,1.7-5.4,4.2c-10.7,41.6-48.2,70.7-91.2,70.7 c-43,0-80.4-29.1-91.2-70.7c-0.6-2.5-2.9-4.2-5.4-4.2h-3.2c-13,0-23.5-10.6-23.5-23.5c0-12.3,9.5-22.5,21.6-23.4 c-1.3,4.7-2.3,9.5-2.9,14.4c-0.2,1.5,0.2,3,1.1,4.1s2.2,1.9,3.7,2.1c0.2,0,0.5,0,0.7,0c2.8,0,5.2-2.1,5.6-4.9 c2.6-20.7,12.2-40.2,27.1-55c14.9-14.8,34.5-24.2,55.2-26.7c7.3-0.9,14.3-3.6,20.2-7.8c11.7-8.4,17.3-17.8,17.1-28.6 C167.9,20,156.7,8.8,142.6,8.8c-5.8,0-11.4,2.5-15.5,7c-4.9,5.4-7,11.8-5.8,18.1c1.1,5.7,4.8,10.5,10.1,13.1 c2.8,1.3,6.1,0.2,7.5-2.6c1.3-2.8,0.2-6.1-2.6-7.5c-2-1-3.5-2.9-3.9-5.1c-0.5-2.7,0.6-5.7,3.1-8.4c1.9-2.1,4.6-3.3,7.2-3.3 c7.9,0,14.2,6.4,14.4,14.5c0.1,7-3.8,13.2-12.4,19.3c-4.3,3.1-9.5,5.1-15,5.8c-23.2,2.8-45.1,13.4-61.8,29.9 c-10.3,10.2-18.3,22.5-23.6,35.8h-1.9c-19.1,0-34.7,15.6-34.7,34.7c0,18.8,15,34.1,33.7,34.7c6.5,21.6,19.5,40.2,37.6,53.8 c18.4,13.8,40.3,21.1,63.3,21.1c23,0,44.9-7.3,63.3-21.1c18.1-13.6,31-32.2,37.6-53.8c18.7-0.5,33.7-15.9,33.7-34.7 C276.7,140.8,261.1,125.2,242,125.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.6,155.8c0-5.4-4.4-9.8-9.8-9.8c-5.4,0-9.8,4.4-9.8,9.8s4.4,9.8,9.8,9.8 C114.2,165.6,118.6,161.2,118.6,155.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.2,155.8c0-5.4-4.4-9.8-9.8-9.8s-9.8,4.4-9.8,9.8s4.4,9.8,9.8,9.8S185.2,161.2,185.2,155.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.1,214.6c0.5,0.3,12.8,8.4,29,8.4c9.7,0,18.8-2.8,27.2-8.4c2.6-1.7,3.3-5.2,1.6-7.8 c-0.8-1.2-2.1-2.1-3.6-2.4c-1.5-0.3-3,0-4.2,0.8c-21.5,14.3-42.8,0.6-43.7,0c-2.6-1.7-6-1-7.8,1.6c-0.8,1.2-1.1,2.7-0.8,4.2 C112,212.5,112.8,213.7,114.1,214.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrIconBaby);
export default __webpack_public_path__ + "static/media/SR_Icon_Baby.0eb25e00a112803572522a25d32f9368.svg";
export { ForwardRef as ReactComponent };